module.exports = __webpack_public_path__ + "img/theatres_1.2a3d5b52.png";